import { render, staticRenderFns } from "./SettingsRating.vue?vue&type=template&id=2a09e130&scoped=true"
import script from "./SettingsRating.vue?vue&type=script&lang=js"
export * from "./SettingsRating.vue?vue&type=script&lang=js"
import style0 from "./SettingsRating.vue?vue&type=style&index=0&id=2a09e130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a09e130",
  null
  
)

export default component.exports